import { render, staticRenderFns } from "./auctioNotice.vue?vue&type=template&id=e236a0d4&scoped=true&"
import script from "./auctioNotice.vue?vue&type=script&lang=js&"
export * from "./auctioNotice.vue?vue&type=script&lang=js&"
import style0 from "./auctioNotice.vue?vue&type=style&index=0&id=e236a0d4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e236a0d4",
  null
  
)

export default component.exports